import { useCallback } from "react";
import type { LomdaScene } from "@/features/lomdaEditorV2/lib/lomdaTypes";

export interface UseSceneFloatingNavProps {
    scenes: LomdaScene[];
    selectedSceneId: string | null;
    setSelectedSceneId: (sceneId: string | null) => void;
}

export interface UseSceneFloatingNavReturn {
    scenes: LomdaScene[];
    currentIndex: number;
    handleNextScene: () => void;
    handlePreviousScene: () => void;
}

export const useSceneFloatingNav = ({
    scenes,
    selectedSceneId,
    setSelectedSceneId,
}: UseSceneFloatingNavProps): UseSceneFloatingNavReturn => {
    const currentIndex = scenes.findIndex((s) => s.id === selectedSceneId);

    const handleNextScene = useCallback(() => {
        const idx = scenes.findIndex((s) => s.id === selectedSceneId);
        const next = Math.min(idx + 1, scenes.length - 1);
        setSelectedSceneId(scenes[next]?.id ?? selectedSceneId);
    }, [scenes, selectedSceneId, setSelectedSceneId]);

    const handlePreviousScene = useCallback(() => {
        const idx = scenes.findIndex((s) => s.id === selectedSceneId);
        const prev = Math.max(idx - 1, 0);
        setSelectedSceneId(scenes[prev]?.id ?? selectedSceneId);
    }, [scenes, selectedSceneId, setSelectedSceneId]);

    return {
        scenes,
        currentIndex,
        handleNextScene,
        handlePreviousScene,
    };
};
